import { useCallback, useEffect, useRef } from "react";

export const useIntersect = (
  ref: React.RefObject<Element | null> | undefined,
  callback: IntersectionObserverCallback,
  options?: IntersectionObserverInit,
) => {
  const observerRef = useRef<IntersectionObserver | null>(null);

  const observe = useCallback(() => {
    if (ref?.current) {
      observerRef.current?.observe(ref.current);
    }
  }, []);

  const unobserve = useCallback(() => {
    if (ref?.current) {
      observerRef.current?.unobserve(ref.current);
    }
  }, []);

  useEffect(() => {
    if (!ref?.current) {
      return;
    }

    observerRef.current = new IntersectionObserver(callback, options);
    observe();

    return () => {
      unobserve();
      observerRef.current?.disconnect();
    };
  }, [callback, options, observe, unobserve]);
};
